<template>
  <div class="uk-position-relative">
    <div class="tm-pro-comments-box uk-animation-slide-right-medium">
      <div class="uk-box-shadow-medium">
        <div class="uk-text-uppercase uk-padding-small" style="background-color: #e7e7e7">
          <div class="uk-grid tm-grid-xsmall uk-flex-middle" data-uk-grid>
            <div>
              <md-icon>draw</md-icon>
            </div>
            <div>{{ local_page_keys.edit_mode }}</div>
          </div>
        </div>
        <div class="uk-padding-small" style="border: 2px solid #e7e7e7;">
          <div class="uk-grid tm-grid-small uk-child-width-1-1" data-uk-grid>
            <div style="line-height: 1.2">
              {{ selectedRetoucherHeader }}
            </div>
            <div>
              <textarea
                  v-model="comment" id="validatedComment" @input="removeAlertClass"
                  class="md-textarea uk-width-1-1 uk-background-muted uk-padding-small"
                  :placeholder="local_page_keys.placeholder_add_comment">
              </textarea>
            </div>
            <div>
              <div class="orange"
                   v-if="!visibleColor.orange || (!visibleColor.blue && !visibleColor.red && !visibleColor.green && !visibleColor.black && !visibleColor.orange)">
                <button class="uk-button uk-button-border uk-button-small-padding" @click="setVisible('orange', true)"><span
                    class="material-icons">+</span></button>
              </div>
              <div v-if="visibleColor.orange" class="orange uk-grid uk-grid-small uk-flex-middle uk-margin">
                <div class="uk-width-auto">
                  <button class="uk-button uk-button-border uk-button-small-padding" @click="choosecolor('orange')"
                          :class="activeClass('orange')">
                    <md-icon style="color: orange;">mode_edit</md-icon>
                  </button>
                </div>
                <div class="uk-width-expand">
                  <textarea @input="setText('orange')" ref="orangeText"
                            :class="{ 'tm-val-error': colors.includes('orange') && fieldsError.includes('orange'), 'disabled-input':!colors.includes('orange') }"
                            class="uk-textarea orangeText"
                            id="orangeText"
                            :value="fixedPhoto.fields.orange"
                            :disabled="!colors.includes('orange')"
                  >
                  </textarea>
                </div>
                <div class="uk-width-auto">
                  <button @click="deleteColor('orange')"><span class="material-icons">close</span></button>
                </div>
              </div>

              <div class="red" v-if="!visibleColor.red || (!visibleColor.red && !visibleColor.blue && !visibleColor.black && !visibleColor.green)">
                <button class="uk-button uk-button-border uk-button-small-padding" @click="setVisible('red', true)"><span
                    class="material-icons">+</span></button>
              </div>
              <div v-if="visibleColor.red" class="red uk-grid uk-grid-small uk-flex-middle uk-margin">
                <div class="uk-width-auto">
                  <button class="uk-button uk-button-border uk-button-small-padding" @click="choosecolor('red')"
                          :class="activeClass('red')">
                    <md-icon style="color: red;">mode_edit</md-icon>
                  </button>
                </div>
                <div class="uk-width-expand">
                  <textarea @input="setText('red')" ref="redText"
                            :class="{ 'tm-val-error': colors.includes('red') && fieldsError.includes('red'), 'disabled-input':!colors.includes('red') }"
                            class="uk-textarea redText"
                            id="redText"
                            :value="fixedPhoto.fields.red"
                            :disabled="!colors.includes('red')"
                  ></textarea>
                </div>
                <div class="uk-width-auto">
                  <button @click="deleteColor('red')"><span class="material-icons">close</span></button>
                </div>
              </div>

              <div class="blue" v-if="!visibleColor.blue || (!visibleColor.blue && !visibleColor.black && !visibleColor.green)">
                <button class="uk-button uk-button-border uk-button-small-padding" @click="setVisible('blue', true)"><span
                    class="material-icons">+</span></button>
              </div>
              <div v-if="visibleColor.blue" class="blue uk-grid uk-grid-small uk-flex-middle uk-margin">
                <div class="uk-width-auto">
                  <button class="blue uk-button uk-button-border uk-button-small-padding" @click="choosecolor('blue')"
                          :class="activeClass('blue')">
                    <md-icon style="color: blue;">mode_edit</md-icon>
                  </button>
                </div>
                <div class="uk-width-expand">
                  <textarea @input="setText('blue')"
                            ref="blueText"
                            :class="{ 'tm-val-error': colors.includes('blue') && fieldsError.includes('blue'), 'disabled-input':!colors.includes('blue') }"
                            class="uk-textarea blueText"
                            id="blueText"
                            :value="fixedPhoto.fields.blue"
                            :disabled="!colors.includes('blue')"
                  ></textarea>
                </div>
                <div class="uk-width-auto">
                  <button @click="deleteColor('blue')"><span class="material-icons">close</span></button>
                </div>
              </div>

              <div class="green" v-if="!visibleColor.green && visibleColor.blue">
                <button class="uk-button uk-button-border uk-button-small-padding" @click="setVisible('green',true)"><span
                    class="material-icons">+</span></button>
              </div>
              <div v-if="visibleColor.green" class="green uk-grid uk-grid-small uk-flex-middle uk-margin">
                <div class="uk-width-auto">
                  <button class="uk-button uk-button-border uk-button-small-padding" @click="choosecolor('green')"
                          :class="activeClass('green')">
                    <md-icon style="color: green;">mode_edit</md-icon>
                  </button>
                </div>
                <div class="uk-width-expand">
                  <textarea @input="setText('green')"
                            ref="greenText"
                            :class="{ 'tm-val-error': colors.includes('green') && fieldsError.includes('green'), 'disabled-input':!colors.includes('green') }"
                            class="uk-textarea greenText"
                            id="greenText"
                            :value="fixedPhoto.fields.green"
                            :disabled="!colors.includes('green')"
                  ></textarea>
                </div>
                <div class="uk-width-auto">
                  <button @click="deleteColor('green')"><span class="material-icons">close</span></button>
                </div>
              </div>

              <div class="black" v-if="visibleColor.green && !visibleColor.black">
                <button class="uk-button uk-button-border uk-button-small-padding" @click="setVisible('black', true)"><span
                    class="material-icons">+</span></button>
              </div>
              <div v-if="visibleColor.black" class="black uk-grid uk-grid-small uk-flex-middle uk-margin">
                <div class="uk-width-auto">
                  <button class="uk-button uk-button-border uk-button-small-padding" @click="choosecolor('black')"
                          :class="activeClass('black')">
                    <md-icon style="color: black;">mode_edit</md-icon>
                  </button>
                </div>
                <div class="uk-width-expand">
                  <textarea @input="setText('black')"
                            ref="blackText"
                            :class="{ 'tm-val-error': colors.includes('black') && fieldsError.includes('black'), 'disabled-input':!colors.includes('black') }"
                            class="uk-textarea blackText"
                            id="blackText"
                            :value="fixedPhoto.fields.black"
                            :disabled="!colors.includes('black')"
                  ></textarea>
                </div>
                <div class="uk-width-auto">
                  <button @click="deleteColor('black')"><span class="material-icons">close</span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-grid uk-grid-small uk-child-width-1-2 uk-margin-top uk-flex-center uk-flex-middle" data-uk-grid>
        <div>
          <button @click="$emit('closeModeEdit')" type="button" :disabled="loading"
                  class="uk-button tm-button-grey uk-padding-remove uk-width-1-1 uk-box-shadow-medium">
            {{ local_page_keys.cancellation }}
          </button>
        </div>
        <div>
          <button @click="submitComments" type="button" :disabled="loading"
                  class="uk-button uk-button-danger uk-padding-remove uk-width-1-1 uk-box-shadow-medium">
            {{ local_page_keys.button_redesigning }}
            <md-icon>trending_flat</md-icon>
            <span v-if="loading" class="uk-icon uk-margin-small-left" data-uk-spinner="ratio: 0.8"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import convertBase64ToBlob from "../../../../filters/convertBase64ToBlob";

export default {
  name: "comment-photo-note",
  props: {
    fixedPhoto: {
      type: Object,
      require: true,
    },
    whichRetoucher: {
      type: Object,
      require: true,
    },
    faces: {
      type: [Object, Array],
      require: true
    },
    local_page_keys: {
      type: Object,
      require: true
    },
    prev_status_order: {
      type: String,
      require: true
    },
    auto_order_check: {
      type: Number,
      default: 1
    },
    role: {
      type: String,
      require: true
    },
    orderId: {
      type: Number,
      require: true,
    },
    colors: {
      type: Array,
      require: true,
    },
    cursor: {
      type: String,
      require: true,
    },
    color: {
      type: String,
      require: true,
    },
    history: {
      type: Array,
      require: true,
    },
    selectedRetoucherHeader: {
      type: String,
      require: true,
    },
    selectedRetoucher: {
      type: String,
      require: true,
    },
    rejectedToAnotherRetoucher: {
      type: [String,Boolean],
      require: true,
    },
    visibleColor:{
      type: Object,
      require: true,
    }
  },
  data() {
    return {
      loading: false,
      fieldsError: [],
      comment: ''
    }
  },
  filters: {
    convertBase64ToBlob
  },
  methods: {
    setText(color) {
      this.fieldsError = this.fieldsError.filter(item => item !== color);
      let textArea = document.querySelector('#validatedComment');
      textArea.classList.remove('tm-val-error');
      this.$emit('setText', {color: color, text: this.$refs[color + 'Text'].value});
    },
    setVisible(color, value) {
      this.$emit('setVisibleColor', {color: color, value: value});
    },
    choosecolor(color) {
      this.$emit('setCursor', 'pencil');
      this.$emit('setColor', color);
    },
    deleteColor(color) {
      this.$emit('deleteColor', color);
    },
    canSend() {
      this.fieldsError = [];
      const requiredColors = ['blue', 'red', 'green', 'black', 'orange'];
      for (const color of requiredColors) {
        if (this.colors.includes(color) && (!this.fixedPhoto.fields[color] || this.fixedPhoto.fields[color] === '')) {
          this.fieldsError.push(color);
        }
      }
      return this.fieldsError.length === 0;
    },
    activeClass(color) {
      return (color === this.color ? 'activeColor' : '')
    },
    removeAlertClass(event) {
      let textArea = document.querySelector('#validatedComment');
      textArea.classList.remove('tm-val-error');
    },
    async submitComments() {

      if (this.loading)
        return;

      let validComment = this.comment !== null ? typeof (this.comment) === 'string' && this.comment.trim() !== '' : false;

      if (!this.canSend()) {
        alert(this.local_page_keys.alert_you_did_not_fill_out_the_comments)
        return;
      }

      if (this.colors.length === 0 && !validComment) {
        let textArea = document.querySelector('#validatedComment');
        textArea.classList.add('tm-val-error');
        alert(this.local_page_keys.error_add_comment);
        return;
      }

      let comments = JSON.stringify({
            blue_note: this.colors.includes("blue") ? this.fixedPhoto.fields.blue : null,
            red_note: this.colors.includes("red") ? this.fixedPhoto.fields.red : null,
            green_note: this.colors.includes("green") ? this.fixedPhoto.fields.green : null,
            black_note: this.colors.includes("black") ? this.fixedPhoto.fields.black: null,
            orange_note: this.colors.includes("orange") ? this.fixedPhoto.fields.orange: null,
          }
      );

      let image = this.fixedPhoto.image;
      let msg = this.local_page_keys.alert_you_confirm_the_sending_of_the_photo_for_redesign;

      if (this.prev_status_order === 'hold-admin-new')
        msg = this.local_page_keys.alert_you_confirm_sending_of_a_message_order_accepted;

      let formData = new FormData();
      if(this.whichRetoucher && 'status' in this.whichRetoucher && this.whichRetoucher.status == 'rejected-retoucher') {
        formData.append('retoucher_status',  this.whichRetoucher.status);
      }
      formData.append('status', 're-done-admin');
      formData.append('auto_order_check', new Number(this.auto_order_check).toString());

      if (image !== null) {
        let imgFile = convertBase64ToBlob(image);
        formData.append('fixedPhoto', imgFile);
        formData.append('comments', comments);
      }

      // if (this.selectedRetoucher === this.local_page_keys.select_another_retoucher) {
      //   formData.append('retoucher_status', 'rejected-to-another-retoucher');
      //   formData.append('retoucher_email', this.rejectedToAnotherRetoucher);
      // }

      formData.append('problem_comment', this.comment);
      formData.append('problem_comment_retoucher', this.comment);

      let retoucher_email = typeof this.selectedRetoucherHeader == 'string' ? this.selectedRetoucherHeader : null;
      if (this.selectedRetoucher == this.local_page_keys.select_another_retoucher) {
        formData.append('retoucher_status', 'rejected-to-another-retoucher');
        formData.append('without_reason', this.checkboxCheckboxWithoutReasonValue);
        formData.append('message', this.local_page_keys.chat_rejected_to_another_retoucher);
        retoucher_email = this.rejectedToAnotherRetoucher;
      }
      formData.append('retoucher_email', retoucher_email);

        //console.log(formData);
      //return false;

      //console.log(222, this.whichRetoucher);
      if (confirm(msg)) {
        this.loading = true;
        try {
          if (this.role === 'test-retoucher') {
            await this.$store.dispatch("postProRetoucher/reDoneAdmin", {data: formData, role: 'pro-retoucher'});
          } else {
            await this.$store.dispatch("postProRetoucher/reDoneAdmin", formData);
          }
          data = await this.$store.getters['postProRetoucher/reDoneAdmin'];
          if (data.status === 'ok') {

          } else {
            alert(data.message);
           }
        } catch (e) {

        }
        finally {
          this.loading = false;
          this.$emit('reset', true);
          this.$emit('closeModeEdit')
          this.$emit('reload', true);
        }
      }
    },
  },
  watch: {

  },
  computed: {
    computedWhichRetoucher(){
      return this.whichRetoucher;
    }
  },
}
</script>

<style>

</style>